import React from "react"
import PropTypes from "prop-types"
import { Card, CardContent, Tab, Tabs } from "@mui/material"

import { overviewCardSurfaceSx } from "./OverviewCard"

const overviewTabBarSx = {
  minHeight: 52,
  "& .MuiTabs-indicator": {
    display: "none",
  },
  "& .MuiTabs-flexContainer": {
    gap: 0.5,
  },
  "& .MuiTab-root": {
    textTransform: "none",
    minHeight: 52,
    minWidth: "auto",
    px: 1.75,
    py: 1.25,
    borderRadius: 1.5,
    color: "#6b7280",
    fontWeight: 500,
    fontSize: 14,
    border: "1px solid transparent",
    transition:
      "background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease",
  },
  "& .MuiTab-root.Mui-selected": {
    color: "#4f6df5",
    backgroundColor: "#f3f6ff",
    borderColor: "#b5c0fd",
    fontWeight: 600,
  },
  "& .MuiTab-iconWrapper": {
    margin: 0,
    marginRight: 1,
  },
}

const OverviewTabBar = ({ tabs, value, onChange }) => (
  <Card
    elevation={0}
    sx={{
      ...overviewCardSurfaceSx,
      minHeight: "auto",
    }}
  >
    <CardContent
      sx={{
        py: 1.5,
        px: 1.25,
        "&:last-child": { pb: 1.5 },
      }}
    >
      <Tabs
        value={value}
        onChange={onChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={overviewTabBarSx}
      >
        {tabs.map((tab, index) => {
          const Icon = tab.Icon

          return (
            <Tab
              key={tab.id ?? index}
              id={`overview-tab-${index}`}
              aria-controls={`overview-tabpanel-${index}`}
              icon={<Icon sx={{ fontSize: 20 }} />}
              iconPosition="start"
              label={tab.label}
            />
          )
        })}
      </Tabs>
    </CardContent>
  </Card>
)

OverviewTabBar.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string.isRequired,
      Icon: PropTypes.elementType.isRequired,
    }),
  ).isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default OverviewTabBar
